import {useEffect} from 'react'
import {Box, Flex, Image, Text} from '@chakra-ui/react'
import StarIcon from '@assets/svgs/exam/star-blue.svg'
import ChevronRightIcon from '@assets/svgs/exam/chevron_right.svg'

const UpgradeSentenceDetail = ({
  isOrigin,
  sentence,
  explain,
  showSentenceDetail,
  formatFixText,
  showExplainDetail,
}: any) => {
  //Tính năng click bên ngoài tự động tắt popup
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (!event.target.closest('.upgrade-sentence')) {
        showSentenceDetail('', '')
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  return (
    <Box
      className="upgrade-sentence"
      pointerEvents={'auto'}
      color={'#000'}
      onClick={event => event.stopPropagation()}
      position={'absolute'}
      zIndex={1}
      top={'calc(100% + 12px)'}
      width={'480px'}
      padding={'20px 20px 20px 12px'}
      background={'#fff'}
      borderRadius={'12px'}
      boxShadow={'0px 8px 16px 0px rgba(16, 24, 40, 0.15)'}>
      <Flex gap={'8px'} alignItems={'center'}>
        <Image src={StarIcon} />
        <Text fontSize={'16px'} fontWeight={700}>
          Câu nâng cấp
        </Text>
      </Flex>
      <Flex paddingX={'12px'}>
        <Box paddingLeft={'3px'} borderRight={'2px solid #F0F0F0'}></Box>
        <Box paddingLeft={'24px'} width={'100%'}>
          <Text
            fontSize={'16px'}
            marginY={'16px'}
            padding={'12px'}
            borderRadius={'8px'}
            background={'#E5F2FF'}>
            {formatFixText(sentence.fix_sentence)}
          </Text>
          <Flex flexDirection={'column'} gap={'8px'}>
            {sentence.phrases &&
              sentence.phrases.map((phrase: any, indexPhrase: number) => (
                <Flex
                  key={indexPhrase}
                  justifyContent={'space-between'}
                  alignItems={'start'}>
                  <Flex
                    flexDirection={'column'}
                    padding={'6px 10px'}
                    background={'#F5F5F5'}
                    borderRadius={'8px'}
                    gap={'8px'}>
                    <Flex
                      fontSize={'14px'}
                      fontWeight={'500'}
                      alignItems={'center'}
                      gap={'4px'}
                      onClick={e => showExplainDetail(e, '')}>
                      <Text as="span">
                        {isOrigin ? phrase.origin_phrase : phrase.fix_phrase}
                      </Text>
                      <Image src={ChevronRightIcon} />
                      <Text as="span">{phrase.fix_phrase}</Text>
                      {phrase.explains && (
                        <Text
                          onClick={e => showExplainDetail(e, phrase.explains)}
                          fontSize={'12px'}
                          fontWeight={'800'}
                          padding={'1px 0px 0px 4px'}
                          pointerEvents={
                            explain !== JSON.stringify(phrase.explains)
                              ? 'auto'
                              : 'none'
                          }
                          color={
                            explain !== JSON.stringify(phrase.explains)
                              ? '#1890FF'
                              : 'transparent'
                          }>
                          CHI TIẾT
                        </Text>
                      )}
                    </Flex>
                    {phrase.explains &&
                      explain === JSON.stringify(phrase.explains) && (
                        <Box position={'relative'}>
                          <Box
                            position={'absolute'}
                            content=""
                            width={'6px'}
                            height={'6px'}
                            borderRadius={'50%'}
                            background={'#1890FF'}
                            top={'4px'}
                            left={'4px'}></Box>
                          <Text
                            paddingLeft={'20px'}
                            fontSize={'12px'}
                            fontWeight={'400'}>
                            {phrase.explains}
                          </Text>
                        </Box>
                      )}
                  </Flex>

                  {/* <Image
                    paddingLeft={'8px'}
                    cursor={'pointer'}
                    src={PlusIcon}
                  /> */}
                </Flex>
              ))}
          </Flex>
        </Box>
      </Flex>
    </Box>
  )
}

export default UpgradeSentenceDetail
